<template>
  <div class="Activity">
    <header @click="nav()">
      {{data.header}}
      <i class="el-icon-arrow-right"></i>
    </header>
    <div class="con-img" @click="nav(data1.id, data1.live_url)">
      <img :src="data1.image" />
      <p>
        <span>{{data1.title}}</span>
      </p>
    </div>
    <div>
      <ul>
        <li v-for="item in data2" :key="item.id" @click="nav(item.id, item.live_url)">
          <h3>{{item.title}}</h3>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "Activity",
  props: ["acData"],
  data() {
    return {
      data: this.acData || {},
      pathMap: {
        课程教材: "lesson",
        讲师精选: "teacher",
        校园活动: "school",
        学员风采: "student"
      }
    };
  },
  computed: {
    data1() {
      return this.acData.titles[0] || {};
    },
    data2() {
      let temp = [...this.acData.titles];
      temp.shift();
      return temp;
    }
  },
  methods: {
    // 查看文章详情
    nav(id, url) {
      if (url) {
        window.open(url);
      } else {
        const { href } = this.$router.resolve({
          path: `/${this.pathMap[this.data.header]}/${this.acData.id}${
            id ? "/" + id : ""
          }`
        });
        window.open(href, "_blank");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.Activity {
  overflow: hidden;

  header {
    font-size: 22px;
    color: #d23838;
    letter-spacing: 0.47px;
    margin-bottom: 20px;
    i {
      font-weight: bold;
    }
  }
  :hover {
    cursor: pointer !important;
  }

  .con-img {
    position: relative;
    overflow: hidden;
    cursor: pointer !important;
    font-size: 0;
    height: 180px;

    & > img {
      width: 100%;
      height: 100%;
      top: 0;
      position: relative;
      left: 0;
      transition: transform 0.3s;

      &:hover {
        transform: scale(1.1);
      }
    }

    & > p {
      background: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0),
        rgba(0, 0, 0, 0.6)
      );
      background-image: url("../../assets/Mask.png");
      background-size: 100% 100%;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;

      & > span {
        display: block;
        margin: 10px 40px 10px 10px;
        font-size: 18px;
        color: white;
        letter-spacing: 0;
        line-height: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  ul {
    margin: 0;
    padding: 0 20px 0 25px;
    background: #f4f4f4;
    color: #d8d8d8;

    li {
      position: relative;
      height: 49px;
      line-height: 49px;
      cursor: pointer !important;
      &:first-child {
        border-bottom: 1px dashed #dcdcdc;
      }

      h3 {
        position: absolute;
        width: 100%;
        top: 0;
        margin: 0;
        padding: 10px 10px 10px 0;
        font-size: 16px;
        font-weight: normal;
        color: #242424;
        line-height: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        &:hover {
          color: #c52e0f;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/Activity.vue